import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData} from "features/dinamic";
import { setLoading } from "features/loader";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";

interface AlumnoState {
    status: string;
    error: string;
    estado: number | null;
    alumnoSesionList: any[],
}

const initialState: AlumnoState = {
    status: 'idle',
    error: '',
    estado: null,
    alumnoSesionList: [],

}

export const fetchAlumnoSesion = createAsyncThunk('fetchAlumnoSesion', async ({ idGrupoSesion }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 124;
    const { result, message, data } = await getData({ idsp, idGrupoSesion }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateAsistencia = createAsyncThunk('modifyCreateAsistencia', async ({ idGrupoSesion, alumnos }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 125;
    let alert: AlertInterface;
    const { result, message, data } = await getData({ idsp, idGrupoSesion, alumnos }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    if (result) {
        dispatch(fetchAlumnoSesion({ idGrupoSesion }));
        return { message, data };
    }
    return rejectWithValue(message);
});




export const alumnoSesionSlice = createSlice({
    name: 'alumnoSesion',
    initialState,
    reducers: {
        setalumnoSesionList: (state, action) => {
            state.alumnoSesionList = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAlumnoSesion.pending, (state) => {
                state.status = 'loading';
                state.error = '';
            })
            .addCase(fetchAlumnoSesion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.alumnoSesionList = data ? data : [];
                state.estado = Array.isArray(data) && data.length > 0 ? data[0].estado : null;
            })
            .addCase(fetchAlumnoSesion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectAlumnoSesionList = (state: RootState) => state.facilitadorAlumnoSesion.alumnoSesionList;
export const selectAlumnoSesionEstado = (state: RootState) => state.facilitadorAlumnoSesion.estado;

export const { setalumnoSesionList } = alumnoSesionSlice.actions;


export default alumnoSesionSlice.reducer;
